import LooksOneRoundedIcon from '@mui/icons-material/LooksOneRounded';
import LooksTwoRoundedIcon from '@mui/icons-material/LooksTwoRounded';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import { IntegranteDisponible } from '../../../../store/equiposVentaSlice';

interface Props {
    titulo: string;
    primerIntegrante?: IntegranteDisponible;
    segundoIntegrante?: IntegranteDisponible;
}

export function IntegrantesNuevoEquipo({ titulo, primerIntegrante, segundoIntegrante }: Props) {
    return (
        <div className="border-2 border-slate-300 rounded-md px-2 py-[6px]">
            <p className="text-center font-semibold text-lg">{titulo}</p>


            <div className="flex flex-col gap-y-1">
                <div className="flex gap-x-1 w-full">
                    <div className="flex">
                        <LooksOneRoundedIcon sx={{ width: 20, height: 20 }}/>
                        <Person2RoundedIcon sx={{ width: 20, height: 20 }}/>
                    </div>

                    <div className="w-full flex gap-x-3 justify-between">
                        {primerIntegrante
                        ? 
                        <>
                        <p className="italic font-normal">{primerIntegrante.nombre }</p>
                        <p className={`h-[24px] text-sm border-2 ${primerIntegrante.tipo == "Odontólogos" ?"border-green-700 bg-green-100" : "border-purple-700 bg-purple-100"} px-1 rounded-full`}>
                            {primerIntegrante.tipo}
                        </p>
                        </>
                        : <p className="italic">Seleccionar primer integrante</p>
                        }
                    </div>
                </div>

                <div className="flex gap-x-1 w-full">
                    <div className="flex">
                        <LooksTwoRoundedIcon sx={{ width: 20, height: 20 }}/>
                        <Person2RoundedIcon sx={{ width: 20, height: 20 }}/>
                    </div>

                    <div className="w-full flex gap-x-3 justify-between">
                        {segundoIntegrante
                        ? 
                        <>
                        <p className="italic font-normal">{segundoIntegrante.nombre }</p>
                        <p className={`h-[24px] text-sm border-2 ${segundoIntegrante.tipo == "Odontólogos" ?"border-green-700 bg-green-100" : "border-purple-700 bg-purple-100"} px-1 rounded-full`}>
                            {segundoIntegrante.tipo}
                        </p>
                        </>
                        : <p className="italic">Seleccionar segundo integrante</p>
                        }
                    </div>
                </div>
            </div>

        </div>
    );
}
